import React from 'react';
import { UserIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';

const ChatMessage = ({ message, isUser = false }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`flex max-w-[85%] sm:max-w-md lg:max-w-lg ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
        <div className={`flex-shrink-0 ${isUser ? 'ml-2' : 'mr-2'}`}>
          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
            isUser ? 'bg-primary-100' : 'bg-secondary-100'
          }`}>
            {isUser ? (
              <UserIcon className="w-5 h-5 text-primary-600" />
            ) : (
              <ComputerDesktopIcon className="w-5 h-5 text-secondary-600" />
            )}
          </div>
        </div>
        <div className={`px-3 sm:px-4 py-2 rounded-lg break-words ${
          isUser
            ? 'bg-primary-600 text-white'
            : 'bg-gray-100 text-gray-900'
        }`}>
          <p className="text-sm whitespace-pre-wrap break-words">{message.content}</p>
          <p className={`text-xs mt-1 ${
            isUser ? 'text-primary-200' : 'text-gray-500'
          }`}>
            {formatTime(message.created_at)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;